import { render, staticRenderFns } from "./edit.school.page.vue?vue&type=template&id=4bb38918&"
import script from "./edit.school.page.vue?vue&type=script&lang=js&"
export * from "./edit.school.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports